import React from 'react'

import { firebaseAuth } from '../../firebase'

import { Button, Icon, Input, Form } from 'antd'
const FormItem = Form.Item

const lang = 'en'

const validationMessages = {
  typeEmail: {
    en: 'The input is not valid e-mail',
    de: 'E-Mail ist ungültig'
  },
  requiredEmail: {
    en: 'Please provide your e-mail',
    de: 'Bitte geben Sie Ihre E-Mail Adresse an'
  }
}

class LoginForm extends React.Component {
  state = {
    loading: false
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true })
        this.loginWithEmail(values.email, values.password)
      }
    })
  }

  loginWithEmail = (email, password) => {
    const { form } = this.props

    firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then(() => this.setState({ loading: false }))
      .catch(error => {
        this.setState({ loading: false })
        form.setFields({
          email: {
            value: email,
            errors: [new Error(error.message)]
          }
        })
      })
  }

  render () {
    const { loading } = this.state
    const { form: { getFieldDecorator } } = this.props

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem>
          {getFieldDecorator('email', {
            rules: [
              {
                type: 'email',
                message: validationMessages.typeEmail[lang]
              },
              {
                required: true,
                message: validationMessages.requiredEmail[lang]
              }
            ]
          })(<Input prefix={<Icon type='mail' style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder='Email' />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [
              { required: true, message: 'Please input your Password!' },
              {
                min: 6,
                message: 'Minimum 6 characters'
              }
            ]
          })(
            <Input
              prefix={<Icon type='lock' style={{ color: 'rgba(0,0,0,.25)' }} />}
              type='password'
              placeholder='Password'
            />
          )}
        </FormItem>
        <FormItem>
          <Button type='primary' htmlType='submit' className='login-form-button' loading={loading}>
            Log in with email
          </Button>
        </FormItem>
      </Form>
    )
  }
}

export default Form.create()(LoginForm)



// WEBPACK FOOTER //
// ./src/components/Auth/LoginForm.js